import { render } from "./DefaultPropertyValuesCard.vue?vue&type=template&id=519b5323"
import script from "./DefaultPropertyValuesCard.vue?vue&type=script&lang=js"
export * from "./DefaultPropertyValuesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__